import lodash from 'lodash'
import { filter } from 'lodash'
import { isEmpty } from 'lodash'
import React, { useEffect, useMemo } from 'react'
import styled from 'styled-components'

import {
  FieldPrefix,
  useField,
} from '../../../../../../1stlog-ui/src/components/Field'
import { useFieldArray } from '../../../../../../1stlog-ui/src/components/FieldArray'
import { useForm } from '../../../../../../1stlog-ui/src/components/Form'
import { usePrevious } from '../../../../../../1stlog-ui/src/hooks'
import {
  TOrderEntryService,
  TOrderEntryShipmentService,
} from '../../../AdditionalServices/types'
import { useProductSettings } from '../../../Products'
import ShipmentService from './ShipmentService'

const Wrapper = styled.div``

type TShipmentServicesProps = {
  readonly?: boolean
  hiddenServices?: string[]
}

const ShipmentServices = (
  props: TShipmentServicesProps,
): React.ReactElement => {
  const { readonly, hiddenServices = [] } = props

  const form = useForm()

  const { shipmentServices, settingsId } = useProductSettings()

  const [services, setServices] = useField('shipmentServices', {
    asState: true,
  })

  const { fields } =
    useFieldArray<TOrderEntryShipmentService>('shipmentServices')

  // generate all services (remote and local)
  const previousSettingsId = usePrevious(settingsId)
  const allShipmentServices = useMemo(() => {
    const result: TOrderEntryService[] = []
    lodash.forEach(shipmentServices, (s) => result.push(s))

    // add local services
    // none yet

    // force reset of mainMirror/bool service default values only when the whole product changed
    return result.filter(Boolean).map((service) => {
      const resetBoolDefault = !lodash.isEqual(previousSettingsId, settingsId)
      return { ...service, resetBoolDefault }
    })
  }, [shipmentServices, settingsId])

  // set/update services when a product is changed/refreshed
  useEffect(() => {
    const currentServices = lodash.get(
      form.getState(),
      'values.shipmentServices',
      [],
    )
    // TODO: detect possible changes in incoming service options

    // keep existing service settings
    const newServices = lodash
      .map(allShipmentServices, (service) => {
        const { name } = service
        const currentService = lodash.find(
          currentServices,
          (s) => s.name === name,
        )
        if (currentService) {
          return currentService
        }
        return service
      })

      // enable bool services with defaultValue = true
      .map((service) => {
        const { resetBoolDefault, isMainMirror, values, name } = service
        const currentService = lodash.find(
          currentServices,
          (s) => s.name === name,
        )
        if (!currentService && resetBoolDefault && isMainMirror) {
          const defaultValue = lodash.get(lodash.first(values), 'defaultValue')
          return {
            ...service,
            isEnabled: Boolean(defaultValue),
          }
        }
        return service
      })
    setServices(newServices)
  }, [allShipmentServices])

  if (fields.length < 1) {
    return <></>
  }

  const hasContent =
    !readonly ||
    !isEmpty(
      filter(services, (s) => s.isEnabled && !hiddenServices.includes(s.name)),
    )

  return (
    <Wrapper>
      {hasContent && (
        <>
          {/* <Divider my="sm" variant="dashed" color="gray" /> */}
          <h4 className="mt-2">
            {i18n.t('additional_services2', 'Zusatzservices')}
          </h4>
        </>
      )}
      {fields.map((name: string) => (
        <FieldPrefix prefix={name} key={name} overwritePrefix>
          <ShipmentService
            readonly={readonly}
            hiddenServices={hiddenServices}
          />
        </FieldPrefix>
      ))}
    </Wrapper>
  )
}

export default ShipmentServices
